module.exports = __webpack_public_path__ + "media/next_number_out_5.557e9bb2.mp3";